import axiosInstance from './Instance/axiosInstance';

export interface BackupInfo {
    database: string;
    collections: { name: string; documents: number }[];
    totalDocuments: number;
    generatedAt: string;
}

/** What a backup would contain, without building it. */
export const fetchBackupInfo = (): Promise<BackupInfo> =>
    axiosInstance.get('/settings/backup/info').then(res => res.data);

/**
 * Download the whole database as a zip.
 * Returns the blob and the file name the server suggested.
 */
export const downloadBackup = async (): Promise<{ blob: Blob; fileName: string }> => {
    const response = await axiosInstance.get('/settings/backup', { responseType: 'blob' });

    const disposition: string = response.headers?.['content-disposition'] || '';
    const match = /filename="?([^"]+)"?/.exec(disposition);
    const fallback = `backup-${new Date().toISOString().slice(0, 10)}.zip`;

    return { blob: response.data as Blob, fileName: match?.[1] || fallback };
};
